import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../modal/Modal';
import './style.css';
import './settingsModal.css';
import { getCookieConsent, saveCookieConsent } from '../../helpers/cookieConsent';

const OPTIONAL_CATEGORIES = ['analytics', 'marketing', 'functional'];

const CookieSettingsModal = ({ isOpen, onClose, onSaved }) => {
  const { t } = useTranslation('cookieConsent');
  const [categories, setCategories] = useState({ analytics: false, marketing: false, functional: false });

  useEffect(() => {
    if (!isOpen) return;

    const stored = getCookieConsent();
    setCategories({
      analytics: !!stored?.analytics,
      marketing: !!stored?.marketing,
      functional: !!stored?.functional,
    });
  }, [isOpen]);

  const toggleCategory = (category) => {
    setCategories((prev) => ({ ...prev, [category]: !prev[category] }));
  };

  const savePreferences = () => {
    saveCookieConsent(categories);
    onSaved();
  };

  const acceptAll = () => {
    saveCookieConsent({ analytics: true, marketing: true, functional: true });
    onSaved();
  };

  const rejectNonEssential = () => {
    saveCookieConsent({ analytics: false, marketing: false, functional: false });
    onSaved();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('settings.title')} id="cookie-settings-modal">
      <p className="cookie-settings__description">{t('settings.description')}</p>

      <div className="cookie-settings__list">
        <div className="cookie-settings__row">
          <div className="cookie-settings__row-header">
            <span className="cookie-settings__row-title">{t('settings.categories.necessary.title')}</span>
            <span className="cookie-settings__always">{t('settings.alwaysActive')}</span>
          </div>
          <p className="cookie-settings__row-description">
            {t('settings.categories.necessary.description')}
          </p>
        </div>

        {OPTIONAL_CATEGORIES.map((category) => (
          <div className="cookie-settings__row" key={category}>
            <div className="cookie-settings__row-header">
              <span className="cookie-settings__row-title">
                {t(`settings.categories.${category}.title`)}
              </span>
              <label className="cookie-settings__switch">
                <input
                  type="checkbox"
                  checked={categories[category]}
                  onChange={() => toggleCategory(category)}
                  aria-label={t(`settings.categories.${category}.title`)}
                />
                <span className="cookie-settings__slider" />
              </label>
            </div>
            <p className="cookie-settings__row-description">
              {t(`settings.categories.${category}.description`)}
            </p>
          </div>
        ))}
      </div>

      <div className="cookie-settings__actions">
        <button
          type="button"
          className="cookie-banner__btn cookie-banner__btn--outline"
          onClick={rejectNonEssential}
        >
          {t('settings.rejectNonEssential')}
        </button>
        <button
          type="button"
          className="cookie-banner__btn cookie-banner__btn--outline"
          onClick={acceptAll}
        >
          {t('settings.acceptAll')}
        </button>
        <button
          type="button"
          className="cookie-banner__btn cookie-banner__btn--primary"
          onClick={savePreferences}
        >
          {t('settings.savePreferences')}
        </button>
      </div>
    </Modal>
  );
};

export default CookieSettingsModal;
